import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ContactsService } from '../services/contacts.service';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

@Injectable()
export class ContactListResolver implements Resolve<Observable<string>> {

    constructor(private contactsService: ContactsService) { }

    resolve() {
        return this.contactsService.getContacts().catch(() => {
            return Observable.of('error');
        });
    }

}

